<script lang="ts" setup>
import { ref, onMounted, reactive } from "vue";
import {
  CommonEditControlEmits,
  EditControlProps,
  getDefaultEditorControlConfig,
  mounted,
  valueChanged,
} from "@/editor/EditComponentStatic";
const props = defineProps<EditControlProps>();
const emitFn = defineEmits<CommonEditControlEmits>();

const { config, ui } = getDefaultEditorControlConfig(props, emitFn);
var uiData = reactive(ui);

let icon = "";
let myData = ref<boolean>(false);

const uidata = reactive<EditorControlUiData>(uiData);
onMounted(() => {
  mounted(uiData, props, config);
  if (uiData.data) {
    myData.value = true;
  }
  if (config.column?.meta.icon) {
    icon = config.column.meta.icon;
  }
});
function checkedChanged() {
  valueChanged(config, uidata, myData.value);
}
</script>
<template>
  <div v-if="uiData.showMutable" class="wrap">
    <v-tooltip
      :disabled="!uiData.showtooltip || !uiData.tooltip"
      location="bottom"
      max-width="300px"
      :text="uiData.tooltip"
    >
      <template v-slot:activator="{ props }">
        <v-container icon v-bind="props" class="py-0" fluid>
          <v-switch
            v-if="uiData.description"
            :prepend-icon="icon"
            :label="uiData.description"
            :disabled="uiData.disabled"
            v-model="myData"
            @update:modelValue="checkedChanged"
            color="warning"
            persistent-hint
            :error-messages="uiData.errorText"
            :required="uiData.required"
          ></v-switch>
        </v-container>
        <ValueChangeTracker
          v-if="uiData.isChanged || props.disableValueChangeTracker"
        />
      </template>
    </v-tooltip>
    <!-- {{ myData }} -->
  </div>
</template>
